import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const items = [
  {
    q: "Was kostet die Pflegebox?",
    a: "Die Pflegebox ist für anspruchsberechtigte Personen 100 % kostenlos. Wir rechnen den monatlichen Pauschalbetrag direkt mit Ihrer Pflegekasse ab. Es entstehen keinerlei Eigenkosten – auch nicht für den Versand.",
  },
  {
    q: "Wer hat Anspruch auf die Pflegebox?",
    a: "Anspruch hat jede Person mit anerkanntem Pflegegrad 1 bis 5, die zu Hause gepflegt wird – egal ob durch Angehörige, Freunde oder im Rahmen der Selbstpflege.",
  },
  {
    q: "Welche Produkte sind enthalten?",
    a: "Sie erhalten zum Verbrauch bestimmte Pflegehilfsmittel: Bettschutzeinlagen, Einmalhandschuhe, Hände- und Flächendesinfektion, Mund-Nasen-Schutz, Schutzschürzen und Fingerlinge. Sie wählen Ihre Wunschprodukte selbst aus.",
  },
  {
    q: "Wie schnell wird geliefert?",
    a: "Nach Genehmigung durch die Pflegekasse erhalten Sie Ihre erste Box in der Regel innerhalb von 3–5 Werktagen. Danach erfolgt die Lieferung automatisch jeden Monat.",
  },
  {
    q: "Kann ich die Box jederzeit kündigen?",
    a: "Ja. Sie können die monatliche Lieferung jederzeit pausieren oder vollständig beenden – ohne Frist und ohne Begründung.",
  },
  {
    q: "Muss ich den Antrag selbst stellen?",
    a: "Nein. Wir übernehmen den kompletten Antragsprozess für Sie. Sie füllen lediglich unser Formular aus, der Rest läuft automatisch.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 bg-[#F4F1EB]"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <div className="text-center mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3FA66D] mb-5">
            Häufige Fragen
          </div>
          <h2
            data-testid="faq-headline"
            className="text-4xl sm:text-5xl font-medium tracking-tight text-[#1A1A1F]"
          >
            <span className="text-gradient-dark">Antworten,</span>{" "}
            <span className="text-gradient-green">die helfen.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-2">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#1A1A1F]/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-lg sm:text-xl font-medium text-[#1A1A1F]/90 hover:text-[#3FA66D] py-6 hover:no-underline"
              >
                {it.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-base text-[#5A5F66] leading-relaxed pb-6"
              >
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
